<!-- MenuAsteric Root Component -->
<app-menu-horizontal 
  [microfrontendProps]="microfrontendProps"
  (bannerIdsChange)="onBannerIdsChange($event)">
</app-menu-horizontal>
<app-banner-transversal
  [microfrontendProps]="bannerMicrofrontendProps">
</app-banner-transversal>
